export const SYSTEM_USER_ID = "00000000-0000-4000-8000-000000000000";